import { render, staticRenderFns } from "./ProjectUnitDetailsPm.vue?vue&type=template&id=7b08851d"
import script from "./ProjectUnitDetailsPm.vue?vue&type=script&lang=js"
export * from "./ProjectUnitDetailsPm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports